<div class="wrapper">
  <div class="back-link-container confinement">
    <a routerLink="/navigation" class="back-on-mobile mat-h2 back-link">
      <mat-icon class="back-link-icon">arrow_back</mat-icon>{{ 'NAVBAR.MY_ACCOUNT' | translate }}
    </a>
  </div>
  <mat-card class="upper-card align-center hide-on-desktop confinement">
    <p class="mat-title">{{ 'DASHBOARD.MODIFY_DATA' | translate }}</p>
    <img src="./assets/img/user-image.png" alt="Profile" class="profile-picture" />
    <p class="mat-title">
      {{ address?.firstName }}
      {{ address?.lastName }}
    </p>
  </mat-card>
  <mat-card class="confinement lower-card">
    <mat-card-title class="mat-title title-with-tooltip hide-on-desktop">
      {{ 'ACCOUNT.PROFILE.TITLE' | translate }}
      <span
        class="tooltip-container"
        matTooltip="{{ 'ACCOUNT.PROFILE.ADDRESS_CHANGE_TOOLTIP' | translate }}"
        matTooltipClass="tooltip-text"
        matTooltipTouchGestures="auto"
        ><mat-icon>info_outline</mat-icon>
      </span></mat-card-title
    >
    <mat-card-content class="card-content user-info">
      <div class="hide-on-xs user-info__name">
        <p>
          {{ address?.firstName }}
          {{ address?.lastName }}
        </p>
      </div>
      <div class="user-info__customer-number">
        <label class="mat-caption">{{ 'ACCOUNT.PROFILE.CUSTOMER_NUMBER' | translate }}</label>
        <p>
          {{ (customer | async)?.customerNumber | replaceEmptyWithString : '-' }}
        </p>
      </div>
      <div class="user-info__email">
        <span class="editable-text">
          <label class="mat-caption">{{ 'ACCOUNT.PROFILE.EMAIL' | translate }}</label>
          <br />
          <p>{{ email | replaceEmptyWithString : '-' }}</p>
        </span>
        <!--        <span class="editing-container">-->
        <!--          <a-->
        <!--            class="editing-icon-button"-->
        <!--            routerLink="/navigation/account/profile/change-email"-->
        <!--            mat-icon-button-->
        <!--            color="primary"-->
        <!--          >-->
        <!--            <mat-icon>mode</mat-icon>-->
        <!--          </a>-->
        <!--        </span>-->
      </div>
      <div class="user-info__phone-number">
        <span class="editable-text">
          <label class="mat-caption">{{ 'ACCOUNT.PROFILE.PHONE_NUMBER' | translate }}</label>
          <br />
          <p>{{ (customer | async)?.phoneNumber | replaceEmptyWithString : '-' }}</p>
        </span>
        <span class="editing-container">
          <a
            mat-icon-button
            color="primary"
            class="editing-icon-button"
            routerLink="/navigation/account/address/change-phone-number"
          >
            <mat-icon>mode</mat-icon>
          </a>
        </span>
      </div>
      <div class="user-info__mobile">
        <span class="editable-text">
          <label class="mat-caption">{{ 'ACCOUNT.PROFILE.MOBILE' | translate }}</label>
          <br />
          <p>{{ (customer | async)?.mobile | replaceEmptyWithString : '-' }}</p>
        </span>
        <span class="editing-container">
          <button
            mat-icon-button
            color="primary"
            class="editing-icon-button"
            routerLink="/navigation/account/address/change-mobile"
          >
            <mat-icon>mode</mat-icon>
          </button>
        </span>
      </div>
      <div class="user-info__birthday">
        <span class="editable-text">
          <label class="mat-caption">{{ 'ACCOUNT.PROFILE.BIRTHDAY' | translate }}</label>
          <br />
          <p>{{ (customer | async)?.birthdate | replaceEmptyWithString : '-' }}</p>
        </span>
        <span class="editing-container">
          <button
            mat-icon-button
            color="primary"
            class="editing-icon-button"
            routerLink="/navigation/account/address/change-birthdate"
            [disabled]="!!address?.company && customerSubNr === '0'"
          >
            <mat-icon>mode</mat-icon>
          </button>
        </span>
      </div>
      <!--      <div gdArea="change-login-data" class="mat-card-actions">-->
      <!--        <button mat-button color="primary" (click)="changePassword()">-->
      <!--          {{ 'ACCOUNT.PROFILE.CHANGE_USER_DATA' | translate }}-->
      <!--        </button>-->
      <!--      </div>-->
    </mat-card-content>
  </mat-card>
  <mat-card class="confinement" style="margin-top: 2rem">
    <mat-card-title class="mat-title">{{ 'ACCOUNT.PROFILE.ADDRESS_TITLE' | translate }}</mat-card-title>
    <mat-card-content class="adresses">
      <span class="adresses__address">
        <span *ngIf="address?.company">{{ address?.company }}<br /></span>
        <span *ngIf="address?.firstName || address?.lastName"
          >{{ address?.firstName }}&nbsp;{{ address?.lastName }}<br
        /></span>
        {{ address?.street }}<br />
        <span *ngIf="address?.street2">{{ address?.street2 }}<br /></span>
        {{ address?.postalCode }}&nbsp;{{ address?.city }}<br />
        {{ address?.countryCode }}
      </span>
      <!--    <span class="adresses__favorite-button"-->
      <!--      ><a mat-icon-button (click)="setAsDefault.emit()"-->
      <!--        ><mat-icon color="primary">{{ isSelected ? 'star' : 'star_border' }}</mat-icon></a-->
      <!--      ></span-->
      <!--    >-->
      <div class="adresses__action-buttons">
        <!--      <a mat-icon-button (click)="delete.emit()">-->
        <!--        <mat-icon>delete</mat-icon>-->
        <!--      </a>-->
        <button
          mat-icon-button
          color="primary"
          (click)="edit()"
          [disabled]="!!(address?.company && customerSubNr === '0')"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </mat-card-content>
  </mat-card>
  <br />
  @if (showPasswordReset) {
  <mat-card class="menu-card confinement clickable-card" (click)="changePassword()">
    <div class="icon-container"><mat-icon class="dashboard-icon">key</mat-icon></div>
    <div class="center-dashboard-text">
      <mat-card-title>{{ 'ACCOUNT.PROFILE.CHANGE_PASSWORD_TITLE' | translate }}</mat-card-title>
      <mat-card-content>
        {{ 'ACCOUNT.PROFILE.CHANGE_PASSWORD_DESCRIPTION' | translate }}
      </mat-card-content>
    </div>
  </mat-card>
  }
</div>
